module.exports = __webpack_public_path__ + "assets/restaurant_tag-e2853e.svg";